var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowpreheader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4208 6.28885L1.77773 0.192412C1.07548 -0.302685 0 0.177765 0 1.40232V13.5923C0 14.6908 0.999358 15.3529 1.77773 14.8022L10.4208 8.70867C11.1918 8.1667 11.1943 6.83081 10.4208 6.28885Z",
    fill: "url(#paint0_radial_815_588)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_815_588",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.79762 4.6875) rotate(69.4674) scale(22.775 40.9731)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECC440"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowpreheader);
export default __webpack_public_path__ + "static/media/arrowpreheader.9d4b41786cf0147f93f0bca11000cf7e.svg";
export { ForwardRef as ReactComponent };